import React from 'react'
import { Layout } from 'antd'
import TopHeader from '../topheader/TopHeader'
import Contents from '../contents/Contents';
import './Main.css'

export default function Main() {
  return (
    <Layout>
     <TopHeader></TopHeader>
    </Layout>
  )
}